<template></template>

<script>
import { Avatar } from '@/webGL/objects/Avatar'
import { Loader } from '@/utils/Loader'

import animations from '@/assets/data/animations'
import characters from '@/assets/data/characters'
import { Color, CubeTextureLoader } from 'three'

export default {
  props: {
    character: {
      type: String,
      default: ''
    }
  },

  mounted () {
    this.avatar = new Avatar(characters[this.character], actions => {
      this.actions = actions
    })

    this.avatar.position.z = 250
    this.avatar.position.x = -400


    this.avatar.promise.then(() => {

      Loader.load('/objects/animations/hello.fbx').then(obj => {
        obj.animations[0].name = 'hello'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/important.fbx').then(obj => {
        obj.animations[0].name = 'important'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/infoanoter.fbx').then(obj => {
        obj.animations[0].name = 'infoANoter'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/infoanoter--flip.fbx').then(obj => {
        obj.animations[0].name = 'infoANoterFlip'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/talking.fbx').then(obj => {
        obj.animations[0].name = 'talking'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/tendance.fbx').then(obj => {
        obj.animations[0].name = 'tendance'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/idle.fbx').then(obj => {
        obj.animations[0].name = 'idle'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/locomotions/left--2.fbx').then(obj => {
        obj.animations[0].name = 'left'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/locomotions/right--2.fbx').then(obj => {
        obj.animations[0].name = 'right'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })

      Loader.load('/objects/animations/blowakiss.fbx').then(obj => {
        obj.animations[0].name = 'blowAKiss'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/happy.fbx').then(obj => {
        obj.animations[0].name = 'happy'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/bashfull.fbx').then(obj => {
        obj.animations[0].name = 'bashfull'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/clap.fbx').then(obj => {
        obj.animations[0].name = 'clap'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/hiphop.fbx').then(obj => {
        obj.animations[0].name = 'hiphop'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/jazz.fbx').then(obj => {
        obj.animations[0].name = 'jazz'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/salsa.fbx').then(obj => {
        obj.animations[0].name = 'salsa'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/thinking.fbx').then(obj => {
        obj.animations[0].name = 'thinking'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })
      Loader.load('/objects/animations/victory.fbx').then(obj => {
        obj.animations[0].name = 'victory'
        this.avatar.prepareAnimation(obj, animations.avatar)
      })


      this.$emit('objectReady', this.avatar)

      if (this.character === 'marieCaroline') {
        this.colorShoes()
      }
      // else if (this.character === 'julia') {
      //  this.colorPants()
      // }
      // else if (this.character === 'delphine') {
      //  this.colorHair()
      // }
      this.glassShadow()
    })

    this.$hub.on('animation', this.onAnimate)
    this.$hub.on('player:onPlay', this.avatar.onTalk)
    this.$hub.on('player:onPause', this.avatar.onStopTalk)
  },

  beforeDestroy () {
    this.avatar.destroy()

    this.$hub.off('animation', this.onAnimate)
    this.$hub.off('player:onPlay', this.avatar.onTalk)
    this.$hub.off('player:onPause', this.avatar.onStopTalk)
  },

  methods: {
    onAnimate (event) {
      if (event.startsWith('pause_')) {
        let duration = event.replace('pause_','')
        duration = parseInt(duration) * 1000
        this.avatar.onStopTalk()
        setTimeout(this.avatar.onTalk, duration)
      }
      else {
        if (event === 'side') {
          if (this.avatar.isLeft) {
            this.avatar.setBaseAction('left')
            this.avatar.isLeft = false
          }
          else {
            this.avatar.setBaseAction('right')
            this.avatar.isLeft = true
          }
        }
        else if (event === 'infoANoter') {
          if (this.avatar.isLeft) {
            this.avatar.setBaseAction('infoANoter')
          }
          else {
            this.avatar.setBaseAction('infoANoterFlip')
          }
        }
        else {
          this.avatar.setBaseAction(event)
        }
      }
    },
    colorShoes () {
      const shoes = this.avatar.getObjectByName('Shoes_03')

      const path = "/images/cubemap/"
      const format = '.png'
      const urls = [
        path + 'px' + format, path + 'nx' + format,
        path + 'py' + format, path + 'ny' + format,
        path + 'pz' + format, path + 'nz' + format
      ]

      const textureCube = new CubeTextureLoader().load( urls )

      shoes.material.color.setHex( 0xe4a817 )
      shoes.material.shininess = 10
      shoes.material.envMap = textureCube
      shoes.material.reflectivity = .9
    },
    colorPants () {
      const pants = this.avatar.getObjectByName('Clothes_Bottom_03_Blue003')

      // console.log('pants.material[0]', pants.material[0])
      // pants.material[0].map = null
      // pants.material[0].needsUpdate = true

      pants.material[0].color.setHex( 0xffffff )
    },
    colorHair () {
      const hair = this.avatar.getObjectByName('Hair_Long_Curly')
      hair.material.color.setHex( 0xffee99 )
    },
    glassShadow () {
      this.avatar.traverse(child => {
        if (child.isMesh && child.name.startsWith('Glasses_')) {
          child.castShadow = false
        }
      })
    }
  }
}
</script>